/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React, { useState } from 'react'
import { useServiceContext } from '../../../root'
import ActionsMenu from '../../../components/shared/ActionsMenu'
import { ModalImport } from '../../../components/modals/ModalImport'

interface PageMenuProps {
  onAdd: () => void
  onExportStart?: () => void
  onExportEnd?: () => void
}

const PageMenu: React.FC<PageMenuProps> = ({ onAdd, onExportStart, onExportEnd }) => {
  const context = useServiceContext()
  const { translate } = context.service.filter
  const { toast } = context.service
  const [showImportModal, setShowImportModal] = useState(false)

  const handleExport = async () => {
    try {
      // Start loading
      if (onExportStart) {
        onExportStart()
      }

      // Export all folder types using FOLDER_TYPES entity constant
      await context.api.settings.exportSettingsData('FOLDER_TYPES', undefined, undefined, translate)
    } catch (error) {
      toast.error(translate('SETTINGS_IMPORT_FAIL'))
    } finally {
      // End loading
      if (onExportEnd) {
        onExportEnd()
      }
    }
  }

  const settings = {
    menuId: 'page',
    items: [
      {
        value: 'SETTINGS_FOLDER_ADD',
        action: onAdd
      },
      {
        value: 'SETTINGS_FOLDER_TYPE_IMPORT',
        action: () => {
          setShowImportModal(true)
        }
      },
      {
        value: 'SETTINGS_FOLDER_TYPE_EXPORT',
        action: () => {
          handleExport()
        }
      }
    ],
    isBigMenu: true
  }

  return (
    <>
      <ActionsMenu {...settings} />
      {showImportModal && (
        <ModalImport
          importType={context.constant.system.settings.entities.FOLDER_TYPES}
          show={showImportModal}
          onClose={() => {
            setShowImportModal(false)
          }}
        />
      )}
    </>
  )
}

export default PageMenu
